var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-3 legal-entity"},[_c('v-row',[_c('v-col',{staticClass:"px-md-3",attrs:{"cols":"12","md":"6"}},[_c('router-view')],1),_c('v-col',{staticClass:"px-md-3",attrs:{"cols":"12","md":"6"}},[_c('GuidCard')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }